import { Injectable } from '@angular/core';
import {SchoolModel} from '../../../../models/school/school.model';
import {DropdownModel} from '../../../../models/component/dropdown.model';

@Injectable({
  providedIn: 'root'
})
export class UserSettingsModalService {

  isVisible = false;

  settingsSections = [
    new DropdownModel('profile', 'settings.profileSettings.profile'),
    new DropdownModel('pass', 'settings.passwordSettings.password'),
    new DropdownModel('billing', 'settings.newBillingSettings.billing')
  ];

  currentSection = this.settingsSections[0];

  constructor() { }

  /**
   * Pass in the key in the settings section to make it open on a different page by default
   * @param sectionKey The page you want to open denoted by the section key.
   */
  onShow(sectionKey = this.settingsSections[0].key) {

    this.isVisible = true;

    this.currentSection = this.settingsSections[0];

    // You should not have billing as a teacher
    if (SchoolModel.getCurrent()) {
      this.settingsSections = [
        new DropdownModel('profile', 'settings.profileSettings.profile'),
        new DropdownModel('pass', 'settings.passwordSettings.password')
      ];
    } else {
      this.settingsSections = [
        new DropdownModel('profile', 'settings.profileSettings.profile'),
        new DropdownModel('pass', 'settings.passwordSettings.password'),
        new DropdownModel('billing', 'settings.newBillingSettings.billing')
      ];
    }

    for (const section of this.settingsSections) {
      if (sectionKey === section.key) {
        this.currentSection = section;
        break;
      }
    }

  }

  onHide() {
    this.isVisible = false;
  }

}
